// Imports => React
import React, {useMemo, memo} from 'react';
import {Props} from './ac-grid-column.proptypes';
import clsx from 'clsx';

// Imports => Utilities
import {AcIsObject} from '@asdf-utils';

const _CLASSES = {
  MAIN: 'ac-col',
  AUTO: 'ac-col--auto',
};

const colWidths = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'];

const getColumnSizeClass = (colWidth, colSize) => {
  if (colSize === true || colSize === '') {
    return `${_CLASSES.MAIN}-${colWidth}`;
  } else if (colSize === 'auto') {
    return `${_CLASSES.MAIN}--auto`;
  }

  return `${_CLASSES.MAIN}-${colWidth}-${colSize}`;
};

// Component
const AcColumn = ({widths = colWidths, rel = 'ac-column', className, children, ...rest}) => {
  const getColClassNames = useMemo(() => {
      let colClasses = [_CLASSES.MAIN];
      let n = 0;
      const len = widths.length;

      for (n; n < len; n++) {
      const colWidth = widths[n];
      const columnProp = rest[colWidth];

      if (!columnProp && columnProp !== '') continue;

      if (AcIsObject(columnProp)) {
      const colSizeInterfix = `-${colWidth}-`;
      const colClass = getColumnSizeClass(colWidth, columnProp.size);

      colClasses.push(
          clsx({
            [colClass]: columnProp.size || columnProp.size === '',
            [`order${colSizeInterfix}${columnProp.order}`]:
            columnProp.order || columnProp.order === 0,
            [`offset${colSizeInterfix}${columnProp.offset}`]:
            columnProp.offset || columnProp.offset === 0,
            })
          );
      } else {
        const colClass = getColumnSizeClass(colWidth, columnProp);
        colClasses.push(colClass);
      }
      }

      return colClasses;
  }, [rest, widths]);

  const getStyleClassNames = useMemo(() => {
      const colClasses = getColClassNames;

      return clsx(colClasses, className);
      }, [getColClassNames, className]);

  return (
      <div className={getStyleClassNames} rel={rel} {...rest}>
      {children}
      </div>
      );
};

AcColumn.displayName = 'AcColumn';
AcColumn.propTypes = Props;

export {AcColumn};
export default AcColumn;
